import { sentenceCase } from "change-case";
import { CSSProperties } from "react";
import styled from "styled-components";

import { Vervestatus } from "codegen";
import { Status } from "codegen/models/Status";
import { Filter } from "pages/Strombestilling/components/Filter";
import { OrderStatus } from "pages/Strombestilling/orders/components/OrderStatus";
import { VervingStatus } from "pages/Strombestilling/verving/VervingStatus";

export const FilterTableRoot = styled.table`
	border-collapse: collapse; // keep border-collapse for more consistent layout without extra spacing
	width: 100%;
	& th {
		text-align: left;
		padding: 0.25rem 0.5rem; // ensure headers have consistent padding
	}
	& td {
		padding: 0.25rem 0.5rem;
	}
	& .number {
		text-align: right;
	}
	& tr {
		height: 2.5rem; // ensure consistency across tables
	}
`;

export enum StatusType {
	vanlig = "vanlig",
	verving = "verving",
}

export function OrderFilterTable({
	name,
	data,
	selected,
	setSelected,
	statusType,
	style,
}: {
	readonly name: string;
	readonly data: Record<string, number | undefined>;
	readonly selected: string | null;
	readonly setSelected: (newValue?: string) => void;
	readonly statusType?: StatusType;
	readonly style?: CSSProperties;
}) {
	const isStatus = name === "Status";

	function OrderStatusElement(props: Readonly<{ k: Status }>) {
		const { k } = props;
		return <OrderStatus status={k} onClick={() => setSelected?.(selected === k ? undefined : k)} />;
	}

	function VervingStatusElement(props: Readonly<{ k: Vervestatus }>) {
		const { k } = props;
		return <VervingStatus status={k} onClick={() => setSelected?.(selected === k ? undefined : k)} />;
	}

	const total = Object.entries(data)
		.map(([_, v]) => v)
		.reduce((value, current) => {
			return (current ?? 0) + (value ?? 0);
		}, 0);
	const displayStatus = isStatus || name === "Kanal";
	const totalString = displayStatus ? ` (Totalt: ${total})` : "";

	return (
		<FilterTableWrapper style={style}>
			<FilterTableRoot>
				<thead>
					<tr>
						<th colSpan={2}>{name + totalString}</th>
					</tr>
				</thead>
				<tbody>
					{Object.entries(data).map(([k, v]) => {
						return (
							<tr key={k}>
								<td>
									{isStatus ? (
										statusType === StatusType.verving ? (
											<VervingStatusElement k={k as Vervestatus} />
										) : (
											<OrderStatusElement k={k as Status} />
										)
									) : (
										<Filter onClick={() => setSelected?.(selected === k ? undefined : k)}>{sentenceCase(k)}</Filter>
									)}
								</td>
								<td className="number">{v}</td>
							</tr>
						);
					})}
				</tbody>
			</FilterTableRoot>
		</FilterTableWrapper>
	);
}

export const FilterTableWrapper = styled.div`
	display: flex;
	height: 100%;
	justify-content: space-between;
	flex-direction: column;
	min-width: 11rem;
`;
